<template>
  <div class="login">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
      <el-form-item label="请输入码" prop="num">
        <el-input v-model="ruleForm.num" @keydown.enter.native="submitForm('ruleForm')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">管理</el-button>
      </el-form-item>
    </el-form>
  </div>

  
</template>

<script>
import { mapMutations } from 'vuex';
// import qs from 'qs';
export default {
  name: 'login',
  data() {
    return {
      ruleForm: {
        num: '',
      },
      rules: {
        num: [
          { required: true, message: '请输入码', trigger: 'blur' },
        ],
      },
      userToken: '',
    };
  },
  methods: {
    ...mapMutations(['changeLogin','changeLoginReal']),
    submitForm(formName) {
      let _this=this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios({
            method: 'post',
            url: '/login.do',
            data: {
              'loginNum': _this.ruleForm.num,
            },
            headers:{
              "Authorization":" "
            }
          })
          // this.$axios.post("http://localhost:8888/login",qs.stringify({
          //   'loginNum': _this.ruleForm.num,
          // }))
          .then(res => {  //res是返回结果
            // console.log(res)
            _this.userToken=res.token;
            // // 检查是否有重定向路径
            // const redirect = this.$route.query.redirect 
            // if (redirect) {
            //   // 跳转到原目标页面
            //   this.$router.push(redirect)
            // } else {
            //   // 默认跳转到首页
            //   this.$router.push('/')
            // }
            // console.log(this.userToken)//获取到的token
            if(res.follow=='/main'){
              _this.changeLoginReal({ Authorization: this.userToken });
            }
            _this.changeLogin({ Authorization: this.userToken });
            this.$router.push(res.follow);
            this.$message({//消息提示框
              message: '恭喜你，登录成功',
              type: 'success',
              showClose: true,//是否有关闭按钮
              duration: 1000 //持续时间
            });
          })
          // .catch(err => { //请求失败就会捕获报错信息
          //   console.log('服务器连接失败');
          //   console.log(err);
          // })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login{
  height:100%;
  display:flex;
  justify-content: center;
  align-items: center;
}
</style>
